import React from "react";
import DashboardPagSectoin from "../../Sections/DashboardPagSectoin/Content";
const DashboardPage = () => {
  return <DashboardPagSectoin />;
};

export default DashboardPage;
